import React from 'react';
import { FormContext } from '../FormContext';
import InputByType from '../Inputs/InputByType';

export default function SocialMediaLinkInputRow() {
	const formContext = React.useContext(FormContext);
	const {
		rowOptions: { rowTypeData },
	} = formContext;

	const getLabel = () => {
		return (
			<div className="link-option-label">
				{getIcon()}
				<div>{rowTypeData.label}</div>
			</div>
		);
	};

	const getIcon = () => (
		<div
			className={`link-option-label-icon ${rowTypeData.iconCssClass}`}></div>
	);

	return (
		<div className="link-option">
			{getLabel()}
			<InputByType />
		</div>
	);
}
